import type React from "react";
import {
  Command as ShadcnCommand,
  CommandDialog as ShadcnCommandDialog,
  CommandInput as ShadcnCommandInput,
  CommandList as ShadcnCommandList,
  CommandEmpty as ShadcnCommandEmpty,
  CommandGroup as ShadcnCommandGroup,
  CommandItem as ShadcnCommandItem,
  CommandShortcut as ShadcnCommandShortcut,
  CommandSeparator as ShadcnCommandSeparator,
} from "src/shadcn/components/command";

const Command = (props: React.ComponentProps<typeof ShadcnCommand>) => (
  <ShadcnCommand {...props} />
);

const CommandDialog = (
  props: React.ComponentProps<typeof ShadcnCommandDialog>
) => (
  <ShadcnCommandDialog
    overlayClassName="supports-backdrop-filter:backdrop-blur-none"
    {...props}
  />
);

const CommandInput = (
  props: React.ComponentProps<typeof ShadcnCommandInput>
) => <ShadcnCommandInput {...props} />;

const CommandList = (props: React.ComponentProps<typeof ShadcnCommandList>) => (
  <ShadcnCommandList {...props} />
);

const CommandEmpty = (
  props: React.ComponentProps<typeof ShadcnCommandEmpty>
) => <ShadcnCommandEmpty {...props} />;

const CommandGroup = (
  props: React.ComponentProps<typeof ShadcnCommandGroup>
) => <ShadcnCommandGroup {...props} />;

const CommandItem = (props: React.ComponentProps<typeof ShadcnCommandItem>) => (
  <ShadcnCommandItem {...props} />
);

const CommandShortcut = (
  props: React.ComponentProps<typeof ShadcnCommandShortcut>
) => <ShadcnCommandShortcut {...props} />;

const CommandSeparator = (
  props: React.ComponentProps<typeof ShadcnCommandSeparator>
) => <ShadcnCommandSeparator {...props} />;

export {
  Command,
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandShortcut,
  CommandSeparator,
};
